export default __webpack_public_path__ + "static/Typography-4adfc131fc1b315070ea9305475bfa8d.png";